import {
  Box,
  IconButton,
  Link,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { Cart, MenuBar, Search } from "../../../icons";
import { Link as LinkRouter, useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.png";
import { useCheckoutStore } from "../../../store/checkoutStore";

type HeaderMbProps = {
  onClick: () => void;
};

const getStyle = () => {
  const boxHeaderMb: SxProps<Theme> = {
    display: { xs: "flex", md: "none" },
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
  };
  const boxItemMb: SxProps<Theme> = {
    flex: 1,
    display: "flex",
  };
  return { boxHeaderMb, boxItemMb };
};

export const HeaderMb = ({ onClick }: HeaderMbProps) => {
  const styles = getStyle();
  const navigate = useNavigate();

  const theme = useTheme();

  const { variants } = useCheckoutStore();

  const onCheckout = () => {
    navigate("/checkout");
  };
  const onSearch = () => {
    navigate("/search");
  };

  return (
    <Box sx={styles.boxHeaderMb}>
      <Box sx={styles.boxItemMb} justifyContent="flex-start">
        <IconButton onClick={onClick}>
          <MenuBar sx={{ width: 20, height: 20 }} />
        </IconButton>
      </Box>
      <Box sx={styles.boxItemMb} justifyContent="center">
        <Link component={LinkRouter} to="">
          <img src={logo} loading="lazy" alt="logo" height={34} />
        </Link>
      </Box>
      <Box sx={styles.boxItemMb} justifyContent="flex-end">
        <IconButton onClick={onSearch}>
          <Search sx={{ width: 20, height: 20 }} />
        </IconButton>
        <IconButton onClick={onCheckout}>
          <Box
            sx={{
              position: "absolute",
              right: -3,
              padding: "2px 6px",
              top: -4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "100vmax",
              backgroundColor: theme.palette.primary[800],
            }}
          >
            <Typography
              fontSize={10}
              fontWeight={600}
              color={theme.palette.common.white}
            >
              {variants.reduce((acc, q) => acc + q.qty, 0)}
            </Typography>
          </Box>
          <Cart sx={{ width: 20, height: 20 }} />
        </IconButton>
      </Box>
    </Box>
  );
};
